import req from './request'

const DEFAULT_ENDPOINTS = {
    certificate: '/provider/certificate',
}

export default {
    certificate(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.certificate, param)
    },
}
